import { ICellConfig } from './ICellConfig';
import { IClient } from '../IClient';
import { KPIType } from './ICreateGeoTestRequest';
import { IConversionType } from '../PlatformModels';

export enum KpiStateHistory {
  SINGLE_TO_MULTIPLE = 'SINGLE_TO_MULTIPLE',
  MULTIPLE_TO_MULTIPLE = 'MULTIPLE_TO_MULTIPLE',
  SINGLE_TO_MULTIPLE_IN_RETRO = 'SINGLE_TO_MULTIPLE_IN_RETRO',
  MULTIPLE_TO_MULTIPLE_IN_RETRO = 'MULTIPLE_TO_MULTIPLE_IN_RETRO'
}

export interface ICPAdStudyConfig {
  brandId: number;
  budgetScale: number;
  clientId: number;
  client: IClient;
  conversionTypeId: number;
  timeToConversion: number;
  geoSplitLevel: string;
  geoScopeIds: number[];
  studyId: number;
  studyName: string;
  studyState: { studyId: number; rModTime: string } | null;
  startDate: string;
  endDate: string;
  reportStartDate: string;
  reportEndDate: string;
  preExptStartTime: string;
  preExptEndTime: string;
  exptRefStartTime: string;
  exptRefEndTime: string;
  splitType: string;
  status: string;
  rCreId: string;
  rCreTime: string;
  rModId: string;
  rModTime: string;
  resultUpdatedAt?: string | null;
  cellConfigs: ICellConfig[];
  marketSelectionExecutionId: string;
  dryRunRequired: number;
  dryRunSucceeded: string;
  inventoryRefStartDate?: string;
  inventoryRefEndDate?: string;
  unapprovedGeoIds: number[];
  parentId?: number | null;
  reportingConfigChanges: string | null;
  reportingConfigChangeNote: string;
  disableSync: 0 | 1;
  hasPreExpDates: number;
  disableSyncMessage: string | null;
  disableSyncBy: string | null;
  disableSyncTimestamp: string | Date | null;
  approvedGeos: string | null;
  cellOptions: { label: string; value: ICellConfig }[];
  recommendationResult: string;
  recommendationId?: number;
  designerVersion: 1 | 2;
  lastScheduledDesignerVersion?: 1 | 2 | null;
  isStudyWithVendorRemoval: boolean;
  displayStatus?: string;
  kpiType?: KPIType;
  kpiStateHistory?: KpiStateHistory;
  conversionType?: string;
  multiKpiPrimaryStudyId?: number;
  conversionTypeObj?: IConversionType;
}

export enum RecommendationResult {
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
  TACTIC_NOT_FOUND = 'TACTIC_NOT_FOUND',
  SUCCESS = 'SUCCESS',
  REJECTED = 'REJECTED',
  CUSTOMISED = 'CUSTOMISED',
  MS_EXPIRED = 'MS_EXPIRED'
}
